export { default as AuthenticatedFooter } from './AuthenticatedFooter';
export { default as BrandedFooter } from './BrandedFooter';
export { default as MinimalFooter } from './MinimalFooter';



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Footer/types/index.ts